import React from 'react';
import CompanyResultSection from './CompanyResultSection';

const SearchResults = ({ searchResults, handleCardClick, isMobile }) => {
  return (
    <div className="search-results-container">
      {searchResults.map((company, index) => (
        <CompanyResultSection 
          key={index}
          company={company}
          handleCardClick={handleCardClick}
          isMobile={isMobile}
        />
      ))}
    </div>
  );
};

export default SearchResults;